export default __webpack_public_path__ + "static/media/sun_rays.57d29a85.svg";